"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLOBAL_THROTTLE_DELAY = exports.NAV_RESPONSIVE_BREAKPOINT = void 0;
exports.NAV_RESPONSIVE_BREAKPOINT = "(min-width: 1060px)";
exports.GLOBAL_THROTTLE_DELAY = 250;
